import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { ShortcutHint } from '@/components/home/_components/tombola-shortcut-overlay/_domain/models/shortcut-hint';
import { IModal } from '@/plugins/modal-manager';
import { IWindowLocationPreference } from '@/app-modules/store/modules/user-preferences';

@Component({
  name: 'ShortcutOverlayItemComponent'
})
export default class ShortcutOverlayItemComponent extends TombolaBaseComponent {
  @Prop() public shortcutHint: ShortcutHint;
  @Prop() public show: boolean;

  private windowLocation: IWindowLocationPreference = null;

  private get modal(): IModal {
    return this.$modalManager.getModal(this.shortcutHint.modalGuid);
  }

  private getWindowLocation(): void {
    if (this.modal.isMinimised && this.modal.minimisedModal) {
      const minModalComponent =  this.modal.minimisedModal.$el;
      this.windowLocation = {
        top: minModalComponent.offsetTop,
        left: minModalComponent.offsetLeft,
        width: minModalComponent.clientWidth,
        height: minModalComponent.clientHeight
      };
    } else {
      this.windowLocation = this.modal.getLocationAndDimensionsInPixels();
    }
  }

  private get style() {
    return {
      top: `${ this.windowLocation.top }px`,
      left: `${ this.windowLocation.left }px`,
      height: `${ this.windowLocation.height }px`,
      width: `${ this.windowLocation.width }px`
    };
  }

  private get isActive(): boolean {
    return this.modal && this.modal.isActive;
  }

  protected created() {
    this.getWindowLocation();
    window.addEventListener('resize', this.getWindowLocation);
    this.$watch('modal', this.getWindowLocation, { immediate: true });
    this.$watch('show', this.getWindowLocation, { immediate: true });
  }

  private beforeDestroy() {
    try {
      window.removeEventListener('resize', this.getWindowLocation);
    }
    catch (e) {
      // do nothing
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/home/_components/tombola-shortcut-overlay/_components/shortcut-overlay-item/shortcut-overlay-item.component.ts